import { faEllipsisVertical, faPenToSquare } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";

import { useCarbonDispatch } from "../../../store/carbonStore";
import { KeycloakUser } from "../../../model/CarbonExternalModels";
import UserForm from "../UserForm";
import UserDelete from "../userDelete/UserDelete";
import UserDisable from "../userDisable/UserDisable";
import UserPassword from "../userPassword/UserPassword";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { Button } from "userful-chronos-common-ui/dist";
import { AppSliceActions } from "../../../store/app/appSlice";

interface IProps {
    user: KeycloakUser;
}

export default function UserActions(props: IProps) {
    const dispatch = useCarbonDispatch();

    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    if (!permissions.isUserSuppressor && !permissions.isUserCreator) return null;

    return (
        <Dropdown onMouseUp={(e) => e.stopPropagation()}>
            <Dropdown.Toggle className="source-actions-menu-toggle" as={Button}>
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="userful-icon-dropdown-menu"
                popperConfig={{ strategy: "fixed" }}
                renderOnMount={true}
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                {permissions.isUserCreator && (
                    <Dropdown.Item
                        onClick={(e) => {
                            e.stopPropagation();
                            dispatch(AppSliceActions.setAppView({ type: "USER", id: props.user.id }));
                        }}
                    >
                        <div className="gcm-icon-dropdown-menu-icon-container">
                            <FontAwesomeIcon icon={faPenToSquare} />
                        </div>
                        <p>Edit</p>
                    </Dropdown.Item>
                )}
                <UserPassword user={props.user} permissions={permissions} />
                {props.user.userProfile.userName !== "admin" && !permissions.isUserCreator && <hr />}
                <UserDisable user={props.user} permissions={permissions} />
                <UserDelete type="DROPDOWN" user={props.user} permissions={permissions} />
            </Dropdown.Menu>
        </Dropdown>
    );
}
